import { render, staticRenderFns } from "./confirmPassword.vue?vue&type=template&id=5716b2fc&scoped=true&"
import script from "./confirmPassword.vue?vue&type=script&lang=js&"
export * from "./confirmPassword.vue?vue&type=script&lang=js&"
import style0 from "./confirmPassword.vue?vue&type=style&index=0&id=5716b2fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716b2fc",
  null
  
)

export default component.exports